module.exports = function (t) {
  return [[18 * t, 18 * t], t + .033];
};



/*****************
 ** WEBPACK FOOTER
 ** ../JSCalligrapher/alphabets/abjad/i3jam.js
 ** module id = 12
 ** module chunks = 0
 **/